import React from 'react';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';

interface EmptyStateProps {
  message?: string;
  subMessage?: string;
  buttonText?: string;
  buttonLink?: string;
  imageSrc?: string;
  imageAlt?: string;
  className?: string;
  hideImage?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  message = 'No items found',
  subMessage = '',
  buttonText,
  buttonLink,
  hideImage = false,
  imageSrc = 'https://placehold.co/400x250?text=No+Data',
  imageAlt = 'No data',
  className = '',
}) => {
  return (
    <div
      className={`page-content d-flex align-items-center justify-content-center ${className}`}
      style={{ height: '80vh', backgroundColor: '#f8f9fa' }}
    >
      <Container className="text-center px-4" style={{ maxWidth: 480 }}>
        {!hideImage && imageSrc && (
          <img
            src={imageSrc}
            alt={imageAlt}
            className="mb-4 shadow-sm rounded"
            style={{
              maxWidth: '100%',
              height: 'auto',
              opacity: 0.85,
              transition: 'transform 0.3s ease',
              cursor: 'default',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          />
        )}

        <h2
          className="mb-3"
          style={{
            color: '#495057',
            fontWeight: 700,
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          }}
        >
          {message}
        </h2>

        {subMessage && (
          <p className="mb-4" style={{ color: '#6c757d', fontSize: '1rem', lineHeight: 1.5 }}>
            {subMessage}
          </p>
        )}

        {buttonText && buttonLink && (
          <Link
            to={buttonLink}
            className="btn btn-primary btn-lg shadow"
            style={{
              borderRadius: '6px',
              paddingLeft: '2rem',
              paddingRight: '2rem',
              fontWeight: 600,
              letterSpacing: '0.03em',
              transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
            }}
            onMouseEnter={(e) => {
              const el = e.currentTarget;
              el.style.backgroundColor = '#0056b3';
              el.style.boxShadow = '0 6px 12px rgba(0, 86, 179, 0.4)';
            }}
            onMouseLeave={(e) => {
              const el = e.currentTarget;
              el.style.backgroundColor = '';
              el.style.boxShadow = '';
            }}
          >
            <i className="mdi mdi-plus-circle-outline me-2" style={{ fontSize: '1.2rem' }}></i>
            {buttonText}
          </Link>
        )}
      </Container>
    </div>
  );
};

export default EmptyState;
